import React from "react";
import { AppBar, Toolbar, MenuItem, Typography } from "@mui/material";

const PageNotFound = () => {
  return <div>404</div>;
};

export default PageNotFound;
